import React, { ReactNode } from 'react'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Typography from '@mui/material/Typography'
import { Circle } from '@mui/icons-material'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import DialogActions from '@mui/material/DialogActions'
import Button from '@mui/material/Button'

function NormalTextList({ items, bulletIcon }: { bulletIcon: ReactNode; items: string[] }) {
    bulletIcon = bulletIcon || <Circle fontSize='12px' />
    return (
        <List>
            {items.map((item) => (
                <ListItem key={item}>
                    <ListItemIcon>{bulletIcon}</ListItemIcon>
                    <ListItemText primary={item} />
                </ListItem>
            ))}
        </List>
    )
}

/**
 * A form for confirming the deletion of an issue.
 */
export function DeleteIssueConfirmationDialog({
    open,
    onClose,
    onDelete,
}: {
    open: boolean
    onClose: () => void
    onDelete: () => Promise<void>
}) {
    const handleDelete = () => void onDelete()

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Radera emission</DialogTitle>
            <DialogContent>
                <Typography>
                    När du raderar en emission kommer alla beroenden också att försvinna, inklusive:
                </Typography>
                <NormalTextList
                    items={[
                        'Länkade rådgivare',
                        'Länkar till andra emissioner',
                        'Investerare (teckningsåtagare, garanter, etc)',
                        'Länkade källor',
                        'Länkar till teckningsoptioner där denna emission är ett ursprung för optionen',
                    ]}
                />
                <Typography>Är du ok med att radera denna emission? Det går inte att ångra raderingen.</Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color='primary'>
                    Avbryt
                </Button>
                <Button onClick={handleDelete} color='primary' autoFocus>
                    Ok, radera
                </Button>
            </DialogActions>
        </Dialog>
    )
}
